import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';
import { OrderHeader } from '../../_models/orderHeader';
import { OrderLine } from '../../_models/orderLine';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';


@Component({
  selector: 'app-return-order',
  templateUrl: './return-order.component.html',
  styleUrls: ['./return-order.component.scss'],
})
export class ReturnOrderComponent implements OnInit {

  tabClicked = "selectedProducts";
  order: OrderHeader = {};
  orderLines: OrderLine[] = [];
  shippingCost: any = [];
  quantityError: string;
  //previousQuantity: number = [];
  selectReasonError: string;
  totalBoxes: number = 0;
  boxHeights: number = 0;
  boxWidths: number = 0;
  boxLengths: number = 0;
  numberOfBoxes: string;
  costEstimateList: any = {};
  costEstimation: any;
  reasonsList: any = [];
  searchError: string = '';

  constructor(private alertService: AlertService, private http: HttpClient, public st: OrderHeader, private g: Globals, private api: ApiIntegration, private route: ActivatedRoute, private router: Router, public user: User) {

    this.api.getOrderDataById(this.route.snapshot.params['id'], this.user.accountOwnerId, "1").subscribe((data: OrderHeader) => {
      this.order = data;
      this.orderLines = _.cloneDeep(this.order.lines);
      this.orderLines.forEach((d) => {
        d['previousQuantity'] = d.quantity;
      });
      this.reasonSettingsList();
    },
      err => {
        this.alertService.error('Error', err);
      });
  }

  reasonSettingsList() {
    this.api.getValues("1", "ACCOUNT_OWNER", (this.user.accountOwnerId || this.order.accountOwnerId), "REASON").subscribe((data: any) => {
      this.reasonsList = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  tabChange(tab) {
    this.tabClicked = tab
  }


  removeProduct(rp) {
    let index = this.orderLines.indexOf(rp);
    this.orderLines.splice(index, 1);
  }

  clearFields() {
    for (let ol of this.orderLines) {
      let i = this.orderLines.indexOf(ol);
      this.orderLines.splice(i, 1);
    }
  }

  ngOnInit() {
  }

  moveToShipping() {
    this.quantityError = "";
    this.selectReasonError = "";
    for (let sl of this.orderLines) {
      if (!sl.quantity || sl.quantity === null || sl.quantity === undefined || (!sl.previousQuantity && sl.quantity <= 0) || (sl.previousQuantity && (sl.previousQuantity < sl.quantity || sl.quantity <= 0))) {
        this.quantityError = 'Please enter quantity as minimum 1 and maxium previous quantity';
      }
    }
    if (!this.orderLines.length) {
      this.quantityError = 'Atleast one product is need to return order';
    }
    if (!this.order.returnReason) {
      this.selectReasonError = 'Please select reason';
    }
    if (this.selectReasonError || this.quantityError) {
      return;
    }
    this.tabClicked = 'shippingOptions';
  }

  checkError() {
    this.selectReasonError = "";
    if (!this.order.returnReason) {
      this.selectReasonError = 'Please select reason';
    }
  }

  Submit() {
    this.quantityError = "";
    this.selectReasonError = "";
    for (let sl of this.orderLines) {
      if (!sl.quantity || sl.quantity === null || sl.quantity === undefined || (!sl.previousQuantity && sl.quantity <= 0) || (sl.previousQuantity && (sl.previousQuantity < sl.quantity || sl.quantity <= 0))) {
        this.quantityError = 'Please enter quantity as minimum 1 and maxium previous quantity';
      }
    }
    if (!this.orderLines.length) {
      this.quantityError = 'Atleast one product is need to return order';
    }
    if (!this.order.returnReason) {
      this.selectReasonError = 'Please select reason';
    }
    if (this.selectReasonError || this.quantityError) {
      return;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createReturnOrders', {
      "accountOwnerContactId": this.order.accountOwnerCustomerId,
      "accountOwnerId": this.order.accountOwnerId,
      "additionalInfo": this.order.additionalInfo,
      "lines": this.orderLines,
      "awbNumber": this.order.awbNumber,
      "connectionName": this.order.connectionName,
      "deliveryInstructions": this.order.deliveryInstructions,
      "externalOrderId": this.order.sourceOrderId || '',
      "externalShipmentId": "string",
      //"inProcessDate": "2020-10-01T02:22:36.391Z",
      "orderNumber": this.order.orderNumber,
      "orderStatus": "SUBMITTED",
      "orderType": this.order.orderType,
      "organizationId": 1,
      "originalOrderDate": this.order.createdDate,
      "originalOrderHeaderId": this.order.orderHeaderId,
      "pickupAddressId": 0,
      "productConfig": this.order.productConfig,
      "providerStatus": this.order.providerStatus,
      "receivedDate": "2020-10-01T02:22:36.392Z",
      "referenceOrderId": "string",
      "returnOrderDate": "string",
      "returnOrderHeaderId": 0,
      "returnReason": this.order.returnReason,
      //"shipmentPrice": 0,
      "shippingMethod": this.order.shippingMethod,
      "shippingOption": this.order.shippingOption,
      "sourceOrderDate": this.order.sourceOrderDate,
      //"sourceType": "string",
      //"trackingNumber": this.order.trackingNumber,
      "warehouseId": this.order.warehouseId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Return Successfully');
          if (this.user.role == "ACCOUNT_OWNER") {
            this.router.navigate(['/admin/orders']);
          } else {
            this.router.navigate(['/admin/adminOrder']);
          }
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  selectCost(c) {
    this.shippingCost = c;
  }

  costEstimate() {
    this.order.shipLines.forEach((ol) => {
      this.boxHeights = (this.boxHeights > ol.boxHeight ? this.boxHeights : ol.boxHeight);
      this.boxWidths = (this.boxWidths > ol.boxWidth ? this.boxWidths : ol.boxWidth);
      this.boxLengths = (this.boxLengths > ol.boxLength ? this.boxLengths : ol.boxLength);
    });
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/costEstimationForShiftAggregator', {
      "accountOwnerId": this.user.accountOwnerId,
      "destPincode": this.order.deliveryAreaPinCode,
      "orderType": "PICK",
      "length": this.boxLengths,
      "breadth": this.boxWidths,
      "height": this.boxHeights,
      "paymentMethod": this.order.paymentMethod,
      "orderValue": this.order.totalValue,
      "organizationId": this.user.organizationId,
      "originPincode": this.order.pickupAreaPinCode,
      "weight": this.order.weightOfOrder
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.costEstimateList = data;
          this.costEstimation = this.costEstimateList.costEstimateList;
          this.alertService.success('Cost Estimation', 'Submitted successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
